class LocalizationForm extends HTMLElement {
  #countrySelect = this.querySelector('#localization-country');
  #countryControl = this.#countrySelect?.querySelector('[data-select-button]');
  #countryList = this.#countryControl?.ariaControlsElements?.[0];
  #countryOptions = this.#countryList?.querySelectorAll('[data-value]');

  #languageField = this.querySelector('[data-localization-language-group]');
  #languageSelect = this.querySelector('#localization-language');
  #languageControl = this.#languageSelect?.querySelector('[data-select-button]');
  #languageList = this.#languageControl?.ariaControlsElements?.[0];
  #languageOptions = this.#languageList?.querySelectorAll('[data-value]');

  connectedCallback() {
    this.#countryOptions?.forEach((option) => {
      option.addEventListener('click', (event) => this.#onCountryChange(event));
    });

    this.#languageOptions?.forEach((option) => {
      option.addEventListener('click', () => this.#onLanguageChange());
    });
  }

  #onCountryChange({ currentTarget }) {
    if (!this.#countryList) return;
    this.#countryList.close();
    if (!this.#languageList || !this.#languageSelect || !this.#languageOptions) return;

    const availableLanguages = this.#getAvailableLanguages(currentTarget);
    this.#toggleLanguageField(availableLanguages.length > 1);
    const nextSelectedOption = this.#getNextSelectedLanguageOption(availableLanguages);

    if (nextSelectedOption) {
      nextSelectedOption.setAttribute('data-selected', '');
      this.#languageSelect.initSelectedOption();
    }
  }

  #getAvailableLanguages(countryOption) {
    return (
      countryOption.dataset.availableLanguages
        ?.split(',')
        .map((languageCode) => languageCode.trim())
        .filter(Boolean) || []
    );
  }

  #toggleLanguageField(hasMultipleLanguages) {
    this.#languageField?.classList.toggle('hidden', !hasMultipleLanguages);
  }

  #getNextSelectedLanguageOption(availableLanguages) {
    const selectedLanguage = this.#languageList?.querySelector('[data-selected]')?.dataset.value;
    let firstVisibleOption;
    let selectedVisibleOption;

    this.#languageOptions?.forEach((option) => {
      option.removeAttribute('data-selected');

      const isVisible = availableLanguages.includes(option.dataset.value);
      option.classList.toggle('hidden', !isVisible);

      if (isVisible && !firstVisibleOption) firstVisibleOption = option;
      if (isVisible && option.dataset.value === selectedLanguage) selectedVisibleOption = option;
    });

    return selectedVisibleOption || firstVisibleOption;
  }

  #onLanguageChange() {
    this.#languageList?.close();
  }
}

customElements.define('localization-form', LocalizationForm);
